import React, { useEffect, useRef, useState } from "react";
import DropDown from "../../Components/UI/Inputs/DropDown";
import useApi from "../../Hooks/useApi";
import useWindowWidth from "../../Hooks/useWindowWidth";
import PieChartContainer from "../../Components/UI/Charts/PieChart/Container";
import GroupStackBarContainer from "../../Components/UI/Charts/GroupStackBarChart/Container";
import MonoContainer from "../../Components/UI/Charts/MonoBarChart/Container";
import EmptyChart from "../../Components/UI/Charts/EmptyChart";
import LineChartContainer from "../../Components/UI/Charts/LineChart/Container";
import { fetchCityList } from "../../Utils/cityProfileUtils";
import { exportChartData } from "../../Utils/chatPageUtils";


const Charts = () => {

  const [selectedCity, setSelectedCity] = useState({ name: "Cumilla", id: 1317, type: "MUNICIPILTY" });
  const [district, setDistrict] = useState({ name: "Cumilla", id: 1317, type: "MUNICIPILTY" });
  const [cityList, setCityList] = useState([]);
  const [selectedYear, setSelectedYear] = useState({ name: "2020", value: 2020 });
  const [yearOptions, setYearOptions] = useState([{ name: "2020", value: 2020 }]);
  const [appliedCity, setAppliedCity] = useState({ name: "Cumilla", id: 1317, type: "MUNICIPILTY" });
  const [appliedYear, setAppliedYear] = useState(2020);
  const [chartType, setChartType] = useState("Bar Chart");
  const [datasetOne, setDatasetOne] = useState({ name: "Containment Type" });
  const [datasetTwo, setDatasetTwo] = useState({
    name: "None"
  });
  const [groupBy, setGroupBy] = useState({ name: "None" });

  const { request } = useApi();
  const width = useWindowWidth();

  const exportRef = useRef();
  const handleExport = () => {
    exportRef.current?.download();
  };
  const handleDataExport = async () => {
    const getSimplifiedChartType = (type = "") => {
      const lower = type.toLowerCase();
      if (lower.includes("line")) return "line";
      if (lower.includes("bar")) return "bar";
      if (lower.includes("pie")) return "pie";
      return "other";
    };

    const simplifiedChartType = getSimplifiedChartType(chartType);
    const query = simplifiedChartType === "line" ? datasetTwo?.name : datasetOne?.name;

    const payload = {
      location: appliedCity?.id,
      query: query,
      year:selectedYear?.value,
      ...(groupBy?.name && groupBy.name !== "None" && { group: groupBy.name }),
    };

    const fileBlob = await exportChartData(request, payload, simplifiedChartType);

    if (fileBlob) {
      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement("a");
      link.href = url;

      // Optional: dynamic filename based on type
      link.download = `${query} - ${simplifiedChartType} chart data ${appliedCity?.name}_${Date.now()}.xls`; // Adjust extension as per file type
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  };





  const chartTypes = [
    { name: "Bar Chart", value: "Bar Chart" },
    { name: "Pie Chart", value: "Pie Chart" },
    { name: "Line Chart", value: "Line Chart" },
  ];

  const sanitationFields = [
    { name: "Structure Type" },
    {
      name: "Drinking Water Source",
    },
    {
      name: "Containment-Tubewell Distance",
    },
    {
      name: "Drinking Water Collector",
    },
    { name: "Flush Type" },
    { name: "Containment Type" },
    { name: "Containment Outlet" },
    { name: "Grey-water Outlet" },
    { name: "Ever Desludged" },
    {
      name: "Disludging Frequency",
    },
    { name: "Sludge Cleaner" },
    { name: "Desludging Process" },
    {
      name: "Suldge Disposal Location",
    },
    { name: "Access Road Type" },
    { name: "Access Vehicle Type" },
    {
      name: "Parking-Containment Distance",
    },
    {
      name: "Solid Waste Collector",
    },
    {
      name: "Waste Disposal Location",
    },
    { name: "Family Income" },
  ];

  const sanitationYearFields = [
    {
      name: "Containment Construction Year",
    },
    {
      name: "Last Desludging Year",
    },
  ];

  const groupBySanitationFields = [
    { name: "None" },
    { name: "Structure Type" },
    { name: "Floor Count" },
    {
      name: "Containment-Tubewell Distance",
    },
    { name: "Containment Type" },
    { name: "Containment Outlet" },
    { name: "Ever Desludged" },
    {
      name: "Disludging Frequency",
    },
    { name: "Sludge Cleaner" },
    { name: "Desludging Process" },
    {
      name: "Suldge Disposal Location",
    },
    { name: "Access Road Type" },
    { name: "Access Vehicle Type" },
    {
      name: "Parking-Containment Distance",
    },
    {
      name: "Solid Waste Collector",
    },
    {
      name: "Waste Disposal Location",
    },
    { name: "Family Income" },
  ];
  const dropDownStyle = {
    width: width >= 340 ? "16rem" : "10rem",
    backgroundColor: "#2F4B7C",
    color: "white",
    paddingLeft: "12px",
  };

  useEffect(() => {
    if (chartType === "Line Chart") {
      if (datasetTwo.name === "None") {
        setDatasetTwo({
          name: "Containment Construction Year",
        });
      } else if (datasetTwo.name !== "None") {
        setDatasetOne({ name: "Containment Type" });
        setGroupBy({ name: "None" });
      }
    }
  }, [chartType, datasetTwo]);

  useEffect(() => {
    if (chartType === "Pie Chart") {
      if (datasetOne.name === "None") {
        setDatasetOne({ name: "Containment Type" });
      } else if (datasetOne.name !== "None") {
        setDatasetTwo({ name: "None" });
        setGroupBy({ name: "None" });
      }
    }
  }, [chartType, datasetOne]);

  useEffect(() => {
    if (chartType === "Bar Chart") {
      if (district && datasetOne.name === "None") {
        setDatasetOne({ name: "Containment Type" });
      } else if (datasetOne.name !== "None") {
        if (datasetTwo.name !== "None") {
          setDatasetTwo({ name: "None" });
        }
      }
    }
  }, [chartType, datasetOne.name, district, datasetTwo.name]);



  const renderChart = () => {
    if (!district || !chartType) return <EmptyChart />;

    if (chartType === "Pie Chart" && datasetOne.name !== "None") {
      return (
        <div className="mt-2 lg:mt-5 xl:mt-10">
          <PieChartContainer

            qus={datasetOne}
            containerClassName={
              "w-full max-w-[350px] md:max-w-[450px] lg:max-w-[550px]"
            }
            exportRef={exportRef}
            selectedCity={appliedCity}
            selectedYear={appliedYear}
          />
        </div>
      );
    }

    if (chartType === "Line Chart" && datasetTwo.name !== "None") {
      return (
        <LineChartContainer

          datasetTwo={datasetTwo}
          containerClassName=""
          exportRef={exportRef}
          selectedCity={appliedCity}
          selectedYear={appliedYear}
        />
      );
    }

    if (chartType === "Bar Chart") {
      if (datasetOne && groupBy?.name === undefined) {
        return (
          <MonoContainer

            datasetOne={datasetOne}
            containerClassName=""
            exportRef={exportRef}
            selectedCity={appliedCity}
            selectedYear={appliedYear}
          />
        );
      } else if (datasetOne && groupBy?.name === "None") {
        return (
          <MonoContainer

            datasetOne={datasetOne}
            containerClassName=""
            exportRef={exportRef}
            selectedCity={appliedCity}
            selectedYear={appliedYear}
          />
        );
      } else if (datasetOne && groupBy?.name !== "None") {
        return (
          <GroupStackBarContainer
            groupBy={groupBy}
            datasetOne={datasetOne}
            containerClassName={""}
            exportRef={exportRef}
            selectedCity={appliedCity}
            selectedYear={appliedYear}
          />
        );
      }
    }

    return null;
  };

  useEffect(() => {
    const fetchCityYearData = async () => {
      await fetchCityList(request, setCityList);
    };
    fetchCityYearData();
  }, []);

  useEffect(() => {
    if (!selectedCity?.id) return;
    const fetchYearOptions = async () => {
      try {
        const response = await request(
          "GET",
          `/v1/survey/city-profile/${selectedCity.id}`,
          {},
          "survey_service"
        );
        if (response?.surveys?.length) {
          const years = response.surveys.map((s) => ({
            name: String(s.year),
            value: s.year,
          }));
          setYearOptions(years);
          setSelectedYear(years[0]);
          // update applied city+year together so charts always get a consistent pair
          setAppliedCity(selectedCity);
          setAppliedYear(years[0].value);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchYearOptions();
  }, [selectedCity?.id]);


  return (
    <div>
      <div className="flex flex-wrap sm:gap-2 lg:gap-4 xl:gap-5 text-left">

        <DropDown
          setter={(value) => {

            setSelectedCity(value);
            setDistrict(value);
          }}
          label="Select City"
          placeholder="Select City"
          value={district}
          options={cityList?.map((city) => ({
            ...city,
            name: city?.name,
            value: city?.id,
          }))}
          style={dropDownStyle}
          baggage={true}
        />

        <DropDown
          label="Select Year"
          placeholder={"Select Year"}
          options={yearOptions}
          value={selectedYear}
          setter={(value) => {
            setSelectedYear(value);
            setAppliedYear(value?.value);
          }}
          style={dropDownStyle}
          baggage={true}
          disabled={!district}
        />

        <DropDown
          label="Chart"
          placeholder={"Chart Type"}
          options={chartTypes}
          value={chartType}
          setter={(value) => setChartType(value)}
          style={dropDownStyle}
          disabled={!district}
        />

        <DropDown
          label="Dataset 01"
          placeholder={"Dataset 01"}
          options={sanitationFields}
          value={datasetOne}
          setter={(value) => setDatasetOne(value)}
          style={dropDownStyle}
          baggage={true}
          searchAble={true}
          disabled={
            !(
              district &&
              (chartType === "Bar Chart" || chartType === "Pie Chart")
            )
          }
        />

        <DropDown
          label="Dataset 02"
          placeholder={"Dataset 02"}
          options={sanitationYearFields}
          value={datasetTwo}
          setter={(value) => setDatasetTwo(value)}
          style={dropDownStyle}
          baggage={true}
          searchAble={true}
          disabled={!(district && chartType === "Line Chart")}
        />

        <DropDown
          label="Group By"
          placeholder={"Group By"}
          options={groupBySanitationFields}
          value={groupBy}
          setter={(value) => setGroupBy(value)}
          style={dropDownStyle}
          baggage={true}
          searchAble={true}
          disabled={!(district && chartType === "Bar Chart")}
        />

        <div className="w-full mt-4 flex gap-2">
          <button
            className="w-[100px] bg-[#2f4b7c] text-white font-bold text-xs py-2 rounded hover:bg-[#1d3557] flex items-center justify-center"
            onClick={handleExport}
            title="Download as PNG"
          >
           Export as PNG
          </button>

          <button
            className="w-[100px] bg-[#2f4b7c] text-white font-bold text-xs py-2 rounded hover:bg-[#1d3557] flex items-center justify-center"
            onClick={handleDataExport}
            title="Download Data"
          >
             Export as XLS
          </button>
        </div>

      </div>


      {renderChart()}
    </div>
  );
};

export default Charts;
